import type { DraftQuestion, GameDraft } from '../../../../shared/drafts';
import type { PublishedGame } from '../../../../shared/publications';

export type BasketLearningChoice = { id: string; label: string; correct: boolean; mediaUrl?: string };
export type BasketLearningQuestion = {
  id: number;
  questionId: string;
  prompt: string;
  promptMediaUrl?: string;
  choices: BasketLearningChoice[];
};
export type BasketLearningConfig = { id: string; questions: BasketLearningQuestion[] };
type Source = Pick<GameDraft | PublishedGame, 'id' | 'maxLevels' | 'questions'>;

function toQuestion(question: DraftQuestion, number: number): BasketLearningQuestion {
  return {
    id: number,
    questionId: question.id,
    prompt: question.prompt,
    promptMediaUrl: question.media?.url,
    choices: question.choices.map((choice) => ({
      id: choice.id,
      label: choice.text,
      correct: choice.isCorrect,
      mediaUrl: choice.media?.url,
    })),
  };
}

export function draftToBasketLearningConfig(source: Source): BasketLearningConfig {
  const questions = Array.from({ length: source.maxLevels }, (_, index) => {
    const number = index + 1;
    const question = source.questions.find((candidate) => candidate.levels[0] === number);
    if (!question) throw new Error(`${number}. Potada Öğren sorusu bulunamadı.`);
    return toQuestion(question, number);
  });
  return { id: source.id, questions };
}
